import { render } from "./RegisterNewView.vue?vue&type=template&id=3f82df28&scoped=true"
import script from "./RegisterNewView.vue?vue&type=script&lang=js"
export * from "./RegisterNewView.vue?vue&type=script&lang=js"

import "./RegisterNewView.vue?vue&type=style&index=0&id=3f82df28&scoped=true&lang=scss"
import "./RegisterNewView.vue?vue&type=style&index=1&id=3f82df28&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f82df28"]])

export default __exports__